<div
	class="recurrency-attempt"
    (click)="isRecurrenctModalOpen = true; trackOpen()"
	[ngStyle]="{ height: _recurrencyAttempt.duration + 'px' }"
>
	<div>
		<span class="freud-icon freud-icon-calendar-times"></span>
		<span>{{ _recurrencyAttempt.contactName }}</span>
	</div>
	<span *ngIf="_recurrencyAttempt.duration > 30">{{
		_recurrencyAttempt.formatedHours
	}}</span>
</div>
<calendar-recurrency-attempt-modal
    [recurrencyAttempt]="_recurrencyAttempt"
	[isOpen]="isRecurrenctModalOpen"
	(onClose)="isRecurrenctModalOpen = false"
></calendar-recurrency-attempt-modal>
